<div [ngClass]="{'text-primary': isPrimary}">
    <ng-content></ng-content>
</div>
